import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Metric } from '../../dto/Metric';
import { ModalButtons } from 'src/app/domain/shared/component/modal-container/modal-container.component';
import { Company } from "../../../pp/dto/Company";

@Component({
  selector: 'app-modal-company-metric-chart',
  templateUrl: './modal-company-metric-chart.component.html',
  styleUrls: ['./modal-company-metric-chart.component.scss'],
})
export class ModalCompanyMetricChartComponent {
  @Input() set metrics(metricRaw: Metric) {
    this.metric = metricRaw;
    this.metric.companyMetrics[0].metricData.forEach((metric) => {
      if (metric.rowValue === '0' || metric.rowValue === '0.0') {
        metric.rowValue = null;
      }
    });
    this.metric.companyMetrics[0].metricData.sort((m1, m2) => m1.period.localeCompare(m2.period));
  };

  @Input() selectedCompany: Company;
  @Input() forComparisonTab = false;
  @Input() metricGroupName: string;
  @Output() confirm = new EventEmitter<boolean>();

  metric: Metric;
  modalButtons: ModalButtons = {
    close: true,
  };

}
